/**
 * Each tab is its own route, `/fleet/<tab>`, and each record lives under its tab, `/fleet/<tab>/<id>`,
 * so the URL, the breadcrumbs and the sidebar's Fleet highlight all agree. Each list keeps its own search and paging in the URL.
 */
export const FLEET_TABS = ['trucks', 'trailers', 'owners'] as const;
export type FleetTab = (typeof FLEET_TABS)[number];

export const FLEET_TAB_LABELS: Record<FleetTab, string> = { trucks: 'Trucks', trailers: 'Trailers', owners: 'Owners' };

export function fleetTabPath(tab: FleetTab): string {
  return `/fleet/${tab}`;
}

export function fleetRecordPath(tab: FleetTab, id: string): string {
  return `/fleet/${tab}/${id}`;
}
